/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>PostHog API field names</blockquote>
 *
 * @example
 * ```typescript
 * import { POSTHOG_FIELDS } from '@shared/reporting';
 *
 * console.log(POSTHOG_FIELDS.DISTINCT_ID); // '$distinct_id'
 * ```
 */
export const POSTHOG_FIELDS = {
  DISTINCT_ID: '$distinct_id',
  DISTINCT_ID_NODE: 'distinctId',
  TIMESTAMP: '$time',
  EVENT: 'event',
  PROPERTIES: '$set',
  RESOURCE: 'resource',
  EVENT_ID: 'event_id'
} as const;
